const routes={
    login : '/login',
    signup : '/signup',
    home : '/home',
    profile : '/profile',
    uibuilder : '/uibuilder',
    uiflow : '/uiflow'
}

export default routes;